module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_kf_pre.014fe81f.png";